"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AndOperation = void 0;
const expression_precedence_1 = require("../expression-precedence");
const types_1 = require("../types");
const binary_operation_1 = require("./binary-operation");
class AndOperation extends binary_operation_1.BinaryOperation {
    constructor(leftOperand, rightOperand) {
        super(leftOperand, rightOperand);
        this[Symbol.toStringTag] = 'AndOperation';
        this.precedence = expression_precedence_1.ExpressionPrecedence.LogicalAnd;
        this.type = types_1.ExpressionType.Boolean;
        this.formattedOperator = 'AND';
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    evaluate(operand) {
        return !!this.leftOperand.evaluate(operand) && !!this.rightOperand.evaluate(operand);
    }
    clone() {
        return new AndOperation(this.leftOperand.clone(), this.rightOperand.clone());
    }
    accept(visitor) {
        visitor.visitAndOperation(this);
    }
}
exports.AndOperation = AndOperation;
//# sourceMappingURL=and-operation.js.map